import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddModals from 'focus_groups/components/add_modals';
import { toggleAddModal } from 'focus_groups/ducks/view_state';

export function mapStateToProps({ project: { focusGroups } }) {
  return {
    ...focusGroups.viewState,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: toggleAddModal,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddModals);



// WEBPACK FOOTER //
// ./focus_groups/containers/add_modals.js